import { Buffer } from 'buffer';

// API
import api from '~/services/api';

// CONSTs
import CONSTS_AS from '~/consts/local_storage';

// FIREBASE
import FirebaseService from './firebase';

// UTILS
import moment from "~/utils/moment";

// verifica se o usuário está logado
const checkUserSession = () => {
    const token = getToken();
    const session_validity = getSessionValidity();

    // verifica se tem o token
    if (token) {

        // verifica se tem validade de sessão
        if (session_validity) {

            // pega o unix timestamp de agora
            const current_utimestamp = parseFloat(moment().unix());

            // se o timestamp atual for menor do que a validade da sessão, está com a sessão valida
            if (current_utimestamp < session_validity) {
                // atualiza a validade da sessão
                refreshSessionValidity();

                // obtém a sessão atualizada
                return getSessionValidity();
            } else {
                // sessão não valida, forçar login
                return false;
            }

        } else {
            // não tem validade, forçar login
            return false;
        }

    } else {
        // não tem token, forçar login
        return false;
    }

}

// pega a validade da sessão atual
const getSessionValidity = () => {
    const session_validity = window.localStorage.getItem(CONSTS_AS.AS_SESSION_VALIDITY);

    if (session_validity !== null) {
        return parseFloat(session_validity);
    } else {
        // usuário não está logado
        return false;
    }
}

// define a validade da sessão
const refreshSessionValidity = () => {
    const validity = moment().add(2, 'hour').unix();
    window.localStorage.setItem(CONSTS_AS.AS_SESSION_VALIDITY, validity);
}

// verifica se o usuário está logado
const getToken = () => {
    const token = window.localStorage.getItem(CONSTS_AS.AS_USER_TOKEN);

    if (token !== null) {
        return token;
    } else {
        // usuário não está logado
        return false;
    }
};

// atualiza o token
const setToken = (token) => {
    window.localStorage.setItem(CONSTS_AS.AS_USER_TOKEN, token);
};

// funcão de login
const login = async (email, senha) => {
    try {

        const baseURL = `?email=${email}&senha=${senha}`;

        const { data: response_data } = await api.get(`/public/administradores/login${baseURL}`, { responseType: 'json' });

        if (response_data.status !== 'error') {
            // gero o token de autenticação
            const token = Buffer.from(`${email}:${senha}`).toString('base64');

            // atualiza os dados do usuário
            setUserData(response_data);

            // atualiza o token
            setToken(token);

            // define a validade da sessão
            refreshSessionValidity();

            // login
            if (response_data?.token_firebase) {
                await FirebaseService.SignInToken(response_data?.token_firebase);
            }

            return true;
        } else {
            throw new Error(response_data.message);
        }

    } catch (error) {
        const response = error?.response?.data || {};

        if (response.message) {
            throw new Error(response.message);
        } else {
            throw error;
        }
    }
};

const logout = async () => {
    window.localStorage.removeItem(CONSTS_AS.AS_USER_TOKEN);
    window.localStorage.removeItem(CONSTS_AS.AS_USER_DATA);
    window.localStorage.removeItem(CONSTS_AS.AS_SESSION_VALIDITY);
    await FirebaseService.SignOut();
}

const setLastUserLogged = async (email = '') => {
    window.localStorage.setItem(CONSTS_AS.AS_LAST_USER_LOGGED, email);
}

const getLastUserLogged = () => {
    const last_user_logged = window.localStorage.getItem(CONSTS_AS.AS_LAST_USER_LOGGED);

    if (last_user_logged !== null) {
        return last_user_logged;
    } else {
        // usuário não está logado
        return '';
    }
}

const setUserData = async (data = {}) => {
    window.localStorage.setItem(CONSTS_AS.AS_USER_DATA, JSON.stringify(data));
}

const getUserData = () => {
    const last_user_logged = window.localStorage.getItem(CONSTS_AS.AS_USER_DATA);

    if (last_user_logged !== null) {
        return JSON.parse(last_user_logged);
    } else {
        // usuário não está logado
        return '';
    }
}

const checkModule = (module = false) => {
    const user = getUserData();

    if (user?.master) {
        return true;
    }

    if (user?.permissoes_organizadas) {

        if (user.permissoes_organizadas[module]) {
            return true;
        } else {
            return false;
        }

    } else {
        return false;
    }
}

const checkPermission = (module = false, access = false) => {
    const user = getUserData();

    if (user?.master) {
        return true;
    }

    if (user?.permissoes_organizadas) {

        if (user.permissoes_organizadas[module]?.[access]) {
            return true;
        } else {
            return false;
        }

    } else {
        return false;
    }
}


const AuthService = {
    login,
    logout,
    getToken,
    setToken,
    setLastUserLogged,
    getLastUserLogged,
    setUserData,
    getUserData,

    // permissões
    checkModule,
    checkPermission,

    // verifica a sessão do usuário
    checkUserSession,
}

export default AuthService;
